import { combineReducers } from '@reduxjs/toolkit'
import { extend } from 'lodash'
import { paginate } from '@reducers/data/paginate.js'
import Types from '../types.js'

const getInitialGroupState = () => ({
  currentPage: 1,
})

const base = (state = {}, action) => {
  const { type } = action
  switch (type) {
    case Types.SETUP_GROUP:
      return setupGroup(state, action)

    case Types.TIMELINES_PAGINATE:
      return paginateTo(state, action)

    default:
      return state
  }
}

const setupGroup = (state, action) => {
  const { payload: groupId } = action
  return {
    ...state,
    [groupId]: getInitialGroupState(),
  }
}

const paginateTo = (state, action) => {
  const {
    payload: { pageNumber, groupId },
  } = action
  return {
    ...state,
    [groupId]: {
      ...state[groupId],
      currentPage: pageNumber,
    },
  }
}

// SELECTORS

const getKey = (groupId, pageNumber) => `group-${groupId}-page-${pageNumber}`
const getTotalsKey = groupId => `group-${groupId}-last-totals`

const getBase = state => state.groupTimelines.base

export const getCurrentPage = (state, props) => {
  const { groupId } = props
  const groupBase = getBase(state)[groupId]
  return groupBase.currentPage
}

const getPaginationBase = state => state.groupTimelines.pagination

export function getLastPaginationTotals(state, props) {
  const { groupId } = props
  const totalsKey = getTotalsKey(groupId)
  return getPaginationBase(state)[totalsKey]
}

export function getPagination(state, props) {
  const { page, groupId } = props
  const lastTotals = getLastPaginationTotals(state, props)
  const paginationBase = getPaginationBase(state)

  const key = getKey(groupId, page)
  let pagination = paginationBase[key]
  if (lastTotals && !pagination) {
    // no pagination for page, respond with previous totals so we can show pagination in the view
    pagination = extend({}, lastTotals, { currentPage: page })
  } else if (lastTotals && pagination && !pagination.hasFetchedBefore) {
    // first time fetching for this page, augment with previous totals so we can show pagination in the view
    pagination = extend({}, pagination, lastTotals, { currentPage: page })
  }
  return pagination
}

export default combineReducers({
  base,
  pagination: paginate({
    mapActionToKey: ({ payload: { pageNumber, groupId } }) => getKey(groupId, pageNumber),
    mapActionToTotalsKey: ({ payload: { groupId } }) => getTotalsKey(groupId),
    types: [Types.TIMELINES_REQUEST, Types.TIMELINES_SUCCESS, Types.TIMELINES_FAILURE],
  }),
})
